import { useState } from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Warning, X } from "@phosphor-icons/react";
import { useApi, fmtDate } from "@/lib/api";

const DEFAULT_THRESHOLD = 6;

export const RunwayAlert = () => {
  const api = useApi();
  const { data } = useQuery({ queryKey: ["dashboard"], queryFn: () => api.get("/dashboard") });
  const { data: alert } = useQuery({ queryKey: ["alert-status", data?.kpis?.zero_cash_date], enabled: !!data, queryFn: () => api.get("/alerts/status") });
  const date = data?.kpis?.zero_cash_date;
  const months = data?.kpis?.runway_months;
  const threshold = alert?.threshold_months ?? DEFAULT_THRESHOLD;
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem("runway-alert-dismissed"));
  if (!alert || !date || months == null || months >= threshold || dismissed === date) return null;
  const dismiss = () => { sessionStorage.setItem("runway-alert-dismissed", date); setDismissed(date); };
  return (
    <div data-testid="runway-alert-banner" role="alert"
      className="border-b border-[#FF5C7A]/40 bg-[#FF5C7A]/10 px-4 md:px-8 py-3 flex items-center gap-3 text-sm fade-up">
      <Warning weight="fill" className="text-[#FF5C7A] shrink-0" size={18} />
      <p className="flex-1">
        <span className="font-semibold text-[#FF8FA3]">Runway alert:</span>{" "}
        cash runs out on <span data-testid="runway-alert-date" className="font-mono">{fmtDate(date)}</span>, only{" "}
        <span data-testid="runway-alert-months" className="font-mono">{Number(months).toFixed(1)}</span> months away (your alert level is {threshold}).{" "}
        <Link to="/app" data-testid="runway-alert-link" className="underline hover:text-[#FF8FA3]">Model a fix</Link>
        {alert?.last_sent_to?.length > 0 && (
          <span data-testid="runway-alert-emailed" className="ml-2 text-xs text-[#A3A3A3]">· Alert emailed to {alert.last_sent_to.join(", ")}</span>
        )}
      </p>
      <button data-testid="runway-alert-dismiss" onClick={dismiss} aria-label="Dismiss" className="text-[#A3A3A3] hover:text-white transition-colors">
        <X size={16} />
      </button>
    </div>
  );
};
